import { render, staticRenderFns } from "./retur-shipment-detail-modal.vue?vue&type=template&id=88c21e00&"
import script from "./retur-shipment-detail-modal.vue?vue&type=script&lang=js&"
export * from "./retur-shipment-detail-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports